import request from '../../utils/request';
import { stringify } from 'qs';

/**消息通知列表 */
export async function noticeList(params) {
  return request(`/api/tscloud-oa/notification-receive/list?${stringify(params)}`);
}

/**通知详情 */
export async function noticeInfo(params) {
  return request(`/api/tscloud-oa/notification/detail?${stringify(params)}`);
}

/**更新已读状态 */
export async function updateReadStatus(params) {
  return request(`/api/tscloud-oa//notification/read?${stringify(params)}`);
}

/**考勤列表 */
export async function kqEmployeeList(params) {
  return request(`/api/tscloud-oa/kq/employee/page?${stringify(params)}`);
}

/**请假列表 */
export async function leaveList(params) {
  return request(`/api/tscloud-oa/leave/page?${stringify(params)}`);
}
/**请假详情 */
export async function leaveInfo(params){
  return request(`/api/tscloud-oa/leave/detail?${stringify(params)}`);
}


/** 未读消息数量 */
export async function unreadNumNotice(params){
  return request(`/api/tscloud-oa/notification-receive/unreadNum?${stringify(params)}`);
}
/** 请假待审核数量 */
export async function auditNumLeave(params){
  return request(`/api/tscloud-oa/leave/auditNum?${stringify(params)}`);
}

/**请假通过、驳回 */
export async function updateLeaveStatus(params){
  return request('/api/tscloud-oa/leave/updateLeaveType', {
    method: 'POST',
    body: params,
  });
}


